/**
 * Represents the action's type
 */
export const enum ActionType {
  CreateObject = 'createObject',
  UpdateObject = 'updateObject',
  DeleteObject = 'deleteObject',
  DeleteMultiObject = 'deleteMultiObject',
  Navigate = 'navigate',
  Logout = 'logout',
  SignUp = 'signup',
  SignIn = 'signin',
  ForgotPassword = 'forgotPassword',
  SetInputValue = 'setInputValue',
  PushNotification = 'pushNotification',
  ExternalLink = 'externalLink',
  Custom = 'custom',
  LineLogin = 'lineLogin',
  DocomoLogin = 'docomoLogin',
  DIDLogin = 'DIDLogin',
  TrustdockLogin = 'trustdockLogin',
  AppleLogin = 'appleLogin',
  SendMail = 'sendMail',
  TrackingAnalytic = 'googleAnalyticsEvent',
  CancelUnivaPaySubscription = 'cancelUnivaPaySubscription',

  CREATE_OBJECT = 'createObject',
  UPDATE_OBJECT = 'updateObject',
  DELETE_OBJECT = 'deleteObject',
  DELETE_MULTI_OBJECT = 'deleteMultiObject',
  UPDATE_MULTIPLE_OBJECT = 'updateMultipleObject',
  CREATE_ASSOCIATION = 'createAssociation',
  DELETE_ASSOCIATION = 'deleteAssociation',
  NAVIGATE = 'navigate',
  AUTHENTICATE = 'authenticate',
  LOGOUT = 'logout',
  SIGNUP = 'signup',
  SIGNIN = 'signin',
  UPDATE_LOGGED_IN = 'updateLoggedIn',
  FORGOT_PASSWORD = 'forgotPassword',
  SHARE = 'share',
  SET_INPUT_VALUE = 'setInputValue',
  FOCUS_ON_INPUT = 'focusOnInput',
  CALL_API = 'callAPI',
  AUTHENTICATE_API = 'authAPI',
  SIGNUP_API = 'signupAPI',
  PUSH_NOTIFICATION = 'pushNotification',
  NOTIFICATION_PERMISSION = 'notificationPermission',
  EXTERNAL_LINK = 'externalLink',
  CUSTOM = 'custom',
  LINE_LOGIN = 'lineLogin',
  DOCOMO_LOGIN = 'docomoLogin',
  DID_LOGIN = 'DIDLogin',
  TRUSTDOCK_LOGIN = 'trustdockLogin',
  CHECK_VERSION = 'checkVersion',
  APPLE_LOGIN = 'appleLogin',
  SEND_EMAIL = 'sendMail',
  TRACKING_ANALYSTIC = 'googleAnalyticsEvent',
  CANCEL_UNIVAPAY_SUBSCRIPTION = 'cancelUnivaPaySubscription',
  CANCEL_CLICKPAY_SUBSCRIPTION = 'cancelClickPaySubscription',
  TORUS_LOGIN = 'TorusLogin',
  SHARE_SNS = 'share_sns',
  FOLLOW = 'follow',
  SEARCH_IN_DB = 'search_in_db',
  SEND_GIFT = 'send_gift',
  PURCHASE_PRODUCT_ALL = 'purchase_product_all',
  CUSTOM_SET_INPUT = 'customSetInput',
  LIVE_STREAM_REQUEST_REVENUES = 'live_stream_request_revenues',
  DISMISS_KEYBOARD = 'dismiss_keyboard',
  DELETE_RECORD_CUSTOM = 'delete_record_custom',
  TEST_CRASH_APP = 'test_crash_app',
  CHANGE_SELECT_VALUE = 'change_select_value',
  COPY_TO_CLIPBOARD = 'copyToClipboard',
  QR_CODE_SCANNER = 'qrCodeScanner',
  NOTIFICATIONS = 'notifications',
  DOWNLOAD_FILE = 'DOWNLOAD_FILE',
  PUSH_STAMP = 'pushStamp',
  AI_FEATURE = 'AI_FEATURE',
  GOOGLE_ANALYTICS_EVENT = 'googleAnalyticsEvent',
  AUTHENTICATE_EXTERNAL = 'authenticateExternal',
  SIGNUP_EXTERNAL = 'signupExternal',
  SEND_MAIL = 'sendMail',
  ID_UNIVAPAY_SUBSCRIPTION = 'idUnivaPaySubscription',
  CREATE_MESSAGE_HISTORY = 'CREATE_MESSAGE_HISTORY',
  EXTERNAL_USER_LOGIN = 'externalUserLogin',
  FIND_ONE_RECORD = 'FIND_ONE_RECORD',
  ENCRYPT_DATA = 'encryptData',
  QUESTIONNAIRE_RECOMMENDATION = 'QUESTIONNAIRE_RECOMMENDATION',
  REMINDER_NOTIFICATION = 'REMINDER_NOTIFICATION',
  EKYC = 'EKYC',
  OPENAI_RESPONSE_TEXT = 'OPENAI_RESPONSE_TEXT',
  OPENAI_ASSISTANT_TEXT = 'OPENAI_ASSISTANT_TEXT',
  GET_IAP_SUBSCRIPTION_STATUS = 'GET_IAP_SUBSCRIPTION_STATUS',
}
